import { get, post } from  "@/utils/request";
/**
 * 分页获取账单列表
 */

export const getCheckListPage = data => post('vegetable_income/getCheckListPage', data);






// WEBPACK FOOTER //
// ./src/api/vegetableIncome.js